import { TriangleAlert, Timer, LogOut } from "lucide-react";

/**
 * Red top-of-page banner shown for the full duration of an active
 * impersonation session. Wires to the impersonation state hook
 * (ROADS-476 deliverable A5) — for the static layer it accepts the
 * target user + minutes-remaining via props so the design showcase
 * page can render a realistic example.
 */
interface ImpersonationBannerProps {
  targetEmail: string;
  minutesRemaining: number;
  operatorName: string;
  onExit?: () => void;
}

export default function ImpersonationBanner({
  targetEmail,
  minutesRemaining,
  operatorName,
  onExit,
}: ImpersonationBannerProps) {
  return (
    <div
      role="alert"
      data-testid="admin-impersonation-banner"
      className="flex items-center gap-4 bg-red-700 px-6 py-3 text-white"
    >
      <div className="flex items-center gap-3">
        <TriangleAlert
          aria-hidden="true"
          className="w-4.5 h-4.5 flex-shrink-0"
        />
        <div className="flex items-center gap-1.5">
          <span className="text-xs font-bold uppercase tracking-widest">
            You are impersonating
          </span>
          <span className="rounded-md bg-black/20 px-2 py-0.5 font-mono text-xs font-semibold">
            {targetEmail}
          </span>
        </div>
      </div>
      <div className="flex-1" />
      <div className="flex items-center gap-2 text-white/90">
        <Timer aria-hidden="true" className="w-3.5 h-3.5" />
        <span className="text-xs font-medium">
          auto-expires in {minutesRemaining} min · every action logged as{" "}
          {operatorName}
        </span>
      </div>
      <button
        type="button"
        onClick={onExit}
        className="flex items-center gap-2 rounded-lg bg-white px-3.5 py-2 text-xs font-bold text-red-700 hover:bg-red-50"
      >
        <LogOut aria-hidden="true" className="w-3 h-3" />
        Exit impersonation
      </button>
    </div>
  );
}
